'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

import { HStack, Spacer } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { AddDataPipelineForm } from './-components/AddDataPipelineForm';
import { InnerNavigation } from './-components/InnerNavigation';

export const Route = createFileRoute(
  '/_staff/settings/data-connector/inbound/data-pipeline/add/',
)({
  component: AddDataPipeline,
});

function AddDataPipeline() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'pages.dataConnector.dataPipeline.add',
  });
  useDocumentTitle(t('pageTitle'));

  return (
    <HStack className="w-full p-6 h-[calc(100vh-64px)]">
      <InnerNavigation />
      <Spacer variant="m" />
      <Suspense fallback={<ViewportLoader />}>
        <AddDataPipelineForm />
      </Suspense>
    </HStack>
  );
}
